import Empty from 'constants/empty';
import { createSelector } from 'reselect';
import { testTargetReadyOffersSelector } from 'selectors/testTarget/offers/testTargetReadyOffersSelector';

const persistFiltersOnCategorySelector = createSelector(testTargetReadyOffersSelector, offers => offers.persistFiltersOnCategory || Empty.Object);

export { persistFiltersOnCategorySelector };
